import { dev } from '$app/environment';

const PATTERN = /(\{\{.*?\}\})/g;

export const getMessage = (messages: Record<string, string>, id: string): string => {
  if (!messages[id]) {
    if (dev) {
      console.error(`Translation '${id}' not found.`);
    }

    return id;
  }

  return messages[id];
};

type Part = { type: 'string' | 'match'; value: string };

export const getParts = (message: string): Part[] => {
  return message.split(PATTERN).map((part) => {
    if (PATTERN.test(part)) {
      return { type: 'match', value: part.replace(/\{|\}/g, '') };
    }

    return { type: 'string', value: part };
  });
};

export const interpolate = (message: string, values: Record<string, string>): string => {
  return getParts(message)
    .map((part) => {
      if (part.type === 'match') {
        if (dev && !values[part.value]) {
          console.error(`Match value '${part.value}' not found.`);
        }

        return values[part.value] || part.value;
      }

      return part.value;
    })
    .join('');
};
